import PageHeader from "@/components/Common/UI/PageHeader";
import ApiRoundedIcon from "@mui/icons-material/ApiRounded";
import SpaceDashboardRoundedIcon from "@mui/icons-material/SpaceDashboardRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import DashboardTab from "./DashboardTab";
import LiveRequestsTab from "./LiveRequestsTab";
import RegistryTab from "./RegistryTab";
import { THEME } from "./theme";

const TABS = [
    { key: "dashboard", label: "Dashboard", icon: <SpaceDashboardRoundedIcon sx={{ fontSize: 18 }} /> },
    { key: "live", label: "Live Requests", icon: <TimelineRoundedIcon sx={{ fontSize: 18 }} /> },
    { key: "registry", label: "API Registry", icon: <ApiRoundedIcon sx={{ fontSize: 18 }} /> },
];

export default function ApiMonitoring() {
    const [tab, setTab] = useState("dashboard");

    return (
        <Box sx={{ bgcolor: THEME.bgDefault, minHeight: "100%", fontFamily: THEME.font }}>
            <PageHeader
                title="API Monitoring"
                subtitle="Real-time request tracing, JVM/host resource usage, and endpoint registry"
            />

            <Box sx={{ borderBottom: `1px solid ${THEME.divider}`, mb: 2.5 }}>
                <Tabs
                    value={tab}
                    onChange={(_, next) => setTab(next)}
                    sx={{
                        minHeight: 40,
                        "& .MuiTab-root": {
                            minHeight: 40,
                            textTransform: "none",
                            fontSize: 13.5,
                            fontWeight: 600,
                            color: THEME.textSecondary,
                            gap: 0.75,
                        },
                        "& .Mui-selected": { color: `${THEME.primary} !important` },
                        "& .MuiTabs-indicator": { bgcolor: THEME.primary, height: 2.5 },
                    }}
                >
                    {TABS.map((t) => (
                        <Tab key={t.key} value={t.key} label={t.label} icon={t.icon} iconPosition="start" />
                    ))}
                </Tabs>
            </Box>

            {tab === "dashboard" && <DashboardTab />}
            {tab === "live" && <LiveRequestsTab />}
            {tab === "registry" && <RegistryTab />}
        </Box>
    );
}
